import React from 'react';

type Props = {
  width?: '60%' | '65%' | '80%';
  className?: string;
  children?: React.ReactNode;
};

const widthClass = {
  '60%': 'w-3/5',
  '65%': 'w-2/3',
  '80%': 'w-4/5',
} as const;

const Container = ({children, width, className}: Props) => (
  <div
    className={`mx-auto pb-20 text-center [&_.table_th]:border-t-0 ${
      width ? widthClass[width] : 'px-24'
    } ${className ?? ''}`}>
    {children}
  </div>
);

export default Container;
